import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SensorDataDto } from "../api/sensorDataApi";

type SensorDashboard = {
    filter: string;
    selectedSensor: SensorDataDto | null;
    isStatusBoardOpen: boolean;
    focusIndex: number;
    searchKeyword: string;
    mapExtent: [number, number, number, number] | null; // [minX, minY, maxX, maxY] in EPSG:3857
    animationOrigin: { x: number; y: number } | null; // 클릭된 탭의 위치 (transform-origin용)
    visibleMarkerCounts: { [key: string]: number }; // 지도에 실제로 표시되는 마커 수 (카테고리별)
    shouldFitOnFilterChange: boolean; // SensorStatusFloating에서 필터 변경 시 fit 실행 여부
}

const initialState: SensorDashboard = {
    filter: "전체",
    selectedSensor: null,
    isStatusBoardOpen: false,
    focusIndex: 0,
    searchKeyword: "",
    mapExtent: null,
    animationOrigin: null,
    visibleMarkerCounts: {},
    shouldFitOnFilterChange: false,
}

const sensorDashboardSlice = createSlice({
    name: "sensorDashboard",
    initialState,
    reducers: {
        setFilter: (state, action: PayloadAction<SensorDashboard["filter"]>) => {
            state.filter = action.payload;
        },
        setSelectedSensor: (state, action: PayloadAction<SensorDataDto | null>) => {
            state.selectedSensor = action.payload;
            // 제품를 선택하면 자동으로 StatusBoard 열기
            if (action.payload !== null) {
                state.isStatusBoardOpen = true;
            }
        },
        setIsStatusBoardOpen: (state, action: PayloadAction<boolean>) => {
            state.isStatusBoardOpen = action.payload;
        },
        setSearchKeyword: (state, action: PayloadAction<string>) => {
            state.searchKeyword = action.payload;
        },
        setMapExtent: (state, action: PayloadAction<[number, number, number, number] | null>) => {
            state.mapExtent = action.payload;
        },
        setFocusIndex: (state, action: PayloadAction<number>) => {
            state.focusIndex = action.payload;
        },
        setAnimationOrigin: (state, action: PayloadAction<{ x: number; y: number } | null>) => {
            state.animationOrigin = action.payload;
        },
        setVisibleMarkerCounts: (state, action: PayloadAction<{ [key: string]: number }>) => {
            state.visibleMarkerCounts = action.payload;
        },
        setShouldFitOnFilterChange: (state, action: PayloadAction<boolean>) => {
            state.shouldFitOnFilterChange = action.payload;
        },
        // 대시보드 상태 초기화 (라우팅 시 호출)
        resetDashboard: () => initialState
    }
})

const sensorDashboardReducer = sensorDashboardSlice.reducer;
export const { setFilter, setSelectedSensor, setIsStatusBoardOpen, setSearchKeyword, setMapExtent, setFocusIndex, setAnimationOrigin, setVisibleMarkerCounts, setShouldFitOnFilterChange, resetDashboard } = sensorDashboardSlice.actions;
export default sensorDashboardReducer;